import { render, staticRenderFns } from "./NearRealTime.vue?vue&type=template&id=35b0f27a&scoped=true"
import script from "./NearRealTime.vue?vue&type=script&lang=js"
export * from "./NearRealTime.vue?vue&type=script&lang=js"
import style0 from "./NearRealTime.vue?vue&type=style&index=0&id=35b0f27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0f27a",
  null
  
)

export default component.exports